import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Utility function to merge Tailwind CSS classes with conditional logic.
 * Combines clsx for conditional classes and tailwind-merge for deduplication.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
